export const columns = [
  {
    Header: 'Número de recarga',
    accessor: 'nAsignacion',
    type: 'clickeable',
  },
  {
    Header: 'Número OC',
    accessor: 'nOC',
    type: 'oc',
  },
  {
    Header: 'Centro de costo',
    accessor: 'CentroCosto',
  },
  {
    Header: 'Sucursal',
    accessor: 'Sucursal',
  },
  {
    Header: 'Tipo de recarga',
    accessor: 'sTipoAsignacion',
  },
  {
    Header: 'Estatus',
    accessor: 'Status',
    type: 'refillStatus',
  },
  {
    Header: 'Fecha asignación',
    accessor: 'dAsignacion',
    type: 'date',
  },
  {
    Header: 'Monto',
    accessor: 'nMontoTotal',
    type: 'currency',
  },
]
